import React from 'react';
import * as SiIcons from 'react-icons/si';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';

const { SiStripe, SiPaypal, SiKlarna, SiSquare } = SiIcons;
const { FaCcVisa, FaCcMastercard } = FaIcons;

const MollieIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.8 14.5h-1.9v-5.2c0-1.2-.7-1.8-1.7-1.8-1.1 0-1.8.8-1.8 2.1v4.9H8.5v-5.2c0-1.2-.7-1.8-1.7-1.8-1.1 0-1.8.8-1.8 2.1v4.9H3.1V8.8h1.9v1.2c.6-.9 1.6-1.4 2.8-1.4 1.4 0 2.4.7 2.9 1.8.6-1.1 1.7-1.8 3.1-1.8 1.9 0 3.1 1.2 3.1 3.2v4.7z"/>
  </svg>
);

const Partners = () => {
  const { t } = useLanguage();
  const partners = [
    { name: "Stripe", icon: SiStripe, color: "hover:text-[#635BFF]" },
    { name: "PayPal", icon: SiPaypal, color: "hover:text-[#003087]" },
    { name: "Klarna", icon: SiKlarna, color: "hover:text-[#FFB3C7]" },
    { name: "Mollie", icon: MollieIcon, color: "hover:text-[#0066FF]" },
    { name: "Square", icon: SiSquare, color: "hover:text-[#3E4347]" },
    { name: "Visa", icon: FaCcVisa, color: "hover:text-[#1A1F71]" },
    { name: "Mastercard", icon: FaCcMastercard, color: "hover:text-[#EB001B]" },
  ];

  return (
    <section className="py-12 bg-white border-b border-slate-100">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-center text-xs font-semibold text-slate-400 tracking-widest uppercase mb-10">
          {t('partners.title')}
        </p>
        <div className="flex flex-wrap justify-center items-center gap-10 md:gap-20">
          {partners.map((partner) => (
            <div 
              key={partner.name} 
              className={`flex items-center gap-3 text-slate-400 transition-all duration-300 cursor-pointer group ${partner.color}`}
            >
              <SafeIcon 
                icon={partner.icon} 
                className="w-8 h-8 md:w-10 md:h-10 transition-transform group-hover:scale-110" 
              />
              <span className="font-bold text-lg md:text-xl tracking-tight text-slate-900/40 group-hover:text-inherit transition-colors">
                {partner.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;